import React from "react";
import Tooltip from "@amzn/meridian/tooltip";

export const ConditionalWrapping = ({condition, wrapper, args, child}) => {
    return condition ? wrapper(child, args) : child;
}

export const tooltipWrapper = (child, {title, position}) => {
    return (
        <Tooltip title={title} position={position}>
            {child}
        </Tooltip>
    )
}


// WEBPACK FOOTER //
// ./src/components/util/ConditionalWrapping.js